/**
 * Back-to-top button for long collection pages. Hidden until the shopper has scrolled about two screens,
 * then fades in; tapping it scrolls smoothly to the top (instantly for reduced-motion shoppers) and moves
 * focus to the main content so keyboard and screen-reader users land in the right place.
 */
class SBackToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.onScroll = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.toggleAttribute('data-visible', window.scrollY > window.innerHeight * 2);
      });
    };
    this.onClick = () => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      document.getElementById('main-content')?.focus({ preventScroll: true });
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.button.addEventListener('click', this.onClick);
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.button?.removeEventListener('click', this.onClick);
    if (this.frame) cancelAnimationFrame(this.frame);
  }
}

if (!customElements.get('s-back-to-top')) customElements.define('s-back-to-top', SBackToTop);
